;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const TOUR_TARGETS = {
	addDashboardViewButton: "tour-add-dashboard-view-button",
	addDashboardViewCancel: "tour-add-dashboard-view-cancel",
	addDashboardViewFooter: "tour-add-dashboard-view-footer",
	addDashboardViewGrid: "tour-add-dashboard-view-grid",
	addDashboardViewSubmit: "tour-add-dashboard-view-submit",
	addDataProviderButton: "tour-add-data-provider-button",
	automationBuilderSteps: "tour-automation-builder-steps",
	automationCreateName: "tour-automation-create-name",
	automationCreateNameComplete: "tour-automation-create-name-complete",
	automationCreateTriggers: "tour-automation-create-triggers",
	automationDestinationStep: "tour-automation-destination-step",
	automationOperationStep: "tour-automation-operation-step",
	automationPublishButton: "tour-automation-publish-button",
	automationSaveDraftButton: "tour-automation-save-draft-button",
	automationSourceStep: "tour-automation-source-step",
	automationsCreateButton: "tour-automations-create-button",
	createDataProviderCredentialsSection:
		"tour-create-data-provider-credentials-section",
	createDataProviderDialog: "tour-create-data-provider-dialog",
	createDataProviderPicker: "tour-create-data-provider-picker",
	createDataProviderSubmit: "tour-create-data-provider-submit",
	dataProviderCard: "tour-data-provider-card",
	dataProviderDelete: "tour-data-provider-delete",
	dataProviderDeleteConfirm: "tour-data-provider-delete-confirm",
	dataProviderDeleteSubmit: "tour-data-provider-delete-submit",
	dataProvidersSection: "tour-data-providers-section",
	deleteDashboardViewButton: "tour-delete-dashboard-view-button",
	deleteDashboardViewConfirm: "tour-delete-dashboard-view-confirm",
	deleteDashboardViewSubmit: "tour-delete-dashboard-view-submit",
	editDashboardViewButton: "tour-edit-dashboard-view-button",
	editDashboardViewSheet: "tour-edit-dashboard-view-sheet",
	inviteEmailField: "tour-invite-email-field",
	inviteEmailSection: "tour-invite-email-section",
	inviteMemberButton: "tour-invite-member-button",
	inviteMembersSheet: "tour-invite-members-sheet",
	invitePermissionsSection: "tour-invite-permissions-section",
	inviteSendButton: "tour-invite-send-button",
	leaderboardBucketEditor: "tour-leaderboard-bucket-editor",
	leaderboardBucketEditorPane: "tour-leaderboard-bucket-editor-pane",
	leaderboardBucketSidebar: "tour-leaderboard-bucket-sidebar",
	leaderboardConfigButton: "tour-leaderboard-config-button",
	leaderboardConfigDialog: "tour-leaderboard-config-dialog",
	leaderboardDisplayMode: "tour-leaderboard-display-mode",
	leaderboardSaveButton: "tour-leaderboard-save-button",
	leaderboardStaffTabs: "tour-leaderboard-staff-tabs",
	portfolioManualSyncButton: "tour-portfolio-manual-sync-button",
	settingsWorkspaceTab: "tour-settings-workspace-tab",
	shareDialogAccessControl: "tour-share-dialog-access-control",
	shareDialogAdvancedSettingsPanel: "tour-share-dialog-advanced-settings-panel",
	shareDialogAdvancedSettingsTrigger:
		"tour-share-dialog-advanced-settings-trigger",
	shareDialogCreate: "tour-share-dialog-create",
	shareDialogCreateSubmit: "tour-share-dialog-create-submit",
	shareDialogInviteSection: "tour-share-dialog-invite-section",
	shareDialogVisualizationsPanel: "tour-share-dialog-visualizations-panel",
	shareDialogVisualizationsTrigger: "tour-share-dialog-visualizations-trigger",
	shareViewButton: "tour-share-view-button",
	sidebarAccountMenu: "tour-sidebar-account-menu",
	sidebarLogoutButton: "tour-sidebar-logout-button",
	sidebarSettingsLink: "tour-sidebar-settings-link",
	sidebarTrigger: "tour-sidebar-trigger",
	sidebarUserMenuTrigger: "tour-sidebar-user-menu-trigger",
	sidebarWorkspaceNav: "tour-sidebar-workspace-nav",
	visualizationGuardConnect: "tour-visualization-guard-connect",
	visualizationGuardEmpty: "tour-visualization-guard-empty",
	workspaceMembersSection: "tour-workspace-members-section",
	workspaceViewRow: "tour-workspace-view-row",
	workspaceViewsSection: "tour-workspace-views-section",
	workspaceViewToggle: "tour-workspace-view-toggle",
} as const;

export type TourTargetId = (typeof TOUR_TARGETS)[keyof typeof TOUR_TARGETS];

export function tourSelector(targetId: TourTargetId): string {
	return `#${targetId}`;
}
